import React, { useState } from "react";
import { Input, Button, Upload, Space, Image, message } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpload } from "@fortawesome/free-solid-svg-icons";
import pushBroadcastApi from "../../../api/push-broadcast-api";

const MAX_SIZE_MB = 5; // khớp limit multer ở BE

/**
 * Ô URL ảnh cho push: dán link HOẶC tải file lên (BE nén + trả URL tuyệt đối).
 * Dùng làm con trực tiếp của Form.Item → nhận value/onChange từ Form.
 *
 * Props: kind "image" | "icon" — BE xử lý khác nhau (JPEG ≤1024px / PNG 256px).
 */
function PushImageUrlUploadInput({ value, onChange, kind = "image", placeholder }) {
    const [uploading, setUploading] = useState(false);
    const [previewError, setPreviewError] = useState(false);

    const setUrl = (url) => {
        setPreviewError(false);
        onChange?.(url);
    };

    const handleUpload = async (file) => {
        if (file.size > MAX_SIZE_MB * 1024 * 1024) {
            message.error(`Ảnh quá ${MAX_SIZE_MB}MB — nén bằng squoosh.app trước nhé`);
            return false;
        }
        try {
            setUploading(true);
            const { data } = await pushBroadcastApi.uploadImage(file, kind);
            setUrl(data.data.url);
            message.success(`Đã tải lên (${Math.round(data.data.size / 1024)}KB)`);
        } catch (err) {
            message.error(err?.response?.data?.message || "Tải ảnh lên thất bại");
        } finally {
            setUploading(false);
        }
        return false; // tự gọi API ở trên, không để antd upload
    };

    return (
        <div className="flex flex-col gap-2">
            <Space.Compact style={{ width: "100%" }}>
                <Input
                    value={value}
                    onChange={(e) => setUrl(e.target.value)}
                    placeholder={placeholder}
                    allowClear
                />
                <Upload
                    accept="image/jpeg,image/png,image/webp"
                    showUploadList={false}
                    beforeUpload={handleUpload}
                    disabled={uploading}
                >
                    <Button loading={uploading} icon={<FontAwesomeIcon icon={faUpload} />}>
                        Tải lên
                    </Button>
                </Upload>
            </Space.Compact>
            {value && (
                <div className="flex items-center gap-2">
                    <Image
                        src={value}
                        height={kind === "icon" ? 48 : 80}
                        style={{ objectFit: "contain", borderRadius: 6 }}
                        onError={() => setPreviewError(true)}
                        onLoad={() => setPreviewError(false)}
                    />
                    {previewError && (
                        <span className="text-xs text-red-500">
                            Không xem được ảnh — link phải trỏ thẳng tới file ảnh (.jpg/.png), không phải trang web
                            như ibb.co/xxx.
                        </span>
                    )}
                </div>
            )}
        </div>
    );
}

export default PushImageUrlUploadInput;
